import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { resetLink } from 'styles/styledComponents/resets';

export const NavLink = styled(Link)`
  ${resetLink}
`;